import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRunkitComponent } from './simple-icons-runkit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRunkitComponent ],
    exports:      [ SimpleIconsRunkitComponent ],
    bootstrap:    []
})
export class SimpleIconsRunkitModule {}
